module.exports = __webpack_public_path__ + "img/defaultProfileImage.a5369809.webp";